import React, { Component } from 'react'
import { Authenticated, GET_LIST, UPDATE } from 'react-admin'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Snackbar from '@material-ui/core/Snackbar'
import CertificationIcon from '@material-ui/icons/CheckCircle';
import { withStyles } from '@material-ui/core/styles';

import CertificationFilters from './CertificationFilters'
import CertificationTable from './CertificationTable'
import dataProvider from '../../utils/dataProvider'


const styles = theme => ({
  title : {
    marginBottom: '20px',
    display: 'inline-flex',
    verticalAlign: 'middle',
    alignItems: 'center',
    fontSize: 23,
    '& svg' : { color: '#019EAC', paddingRight : 10 }
  },
  root: {
    // overflow: 'visible'
  },
  snackbarWarning: {
    backgroundColor: theme.palette.error.light,
  }
})

class Certification extends Component {
  constructor(props) {
    super(props)

    this.state = {
      empresa: false,
      tipoInstalacion: false,
      tipoInstalacionChoices: [],
      datoTecnico: false,
      datoTecnicoChoices: [],
      search: "",

      loading: false,
      tiposInstalaciones: [],
      instalations: {},
      editedInstalations: {},

      sortColumn: "name",
      sortDirection: "ASC",
      visibleIds: [],
      selectedIds: new Set([]),

      totalResults: 0,
      currentPage: 1,
      perPage: 10,

      saving: false,
      snackbarOpen: false
    }

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerPageChange = this.handlePerPageChange.bind(this);
    this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.doTheThing = this.doTheThing.bind(this)
    this.debouncedThing = _.debounce(this.doTheThing, 1000)
    this.handleChangeSelectedStatus = this.handleChangeSelectedStatus.bind(this);
    this.handleChangeAllStatus = this.handleChangeAllStatus.bind(this);
    this.fetchResults = this.fetchResults.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
  }

  handleFilterChange = () => (event, value, old_value, name) => {
    if (name === "tipoInstalacion") {
      const { tiposInstalaciones } = this.state
      const datoTecnicoChoices = _.map(tiposInstalaciones[value].datasheet.properties,
        (value, key) => {
          if (key === "ESTADO_CERTIFICACION") {
            return { value: false, text: "---" }
          }
          return { value: key, text: value.title }
        }
      ).sort((a, b) => {
        if (a.text < b.text) return -1
        if (a.text === b.text) return 0
        return 1
      })

      this.setState({
        tipoInstalacion: value,
        totalResults: 0,
        datoTecnicoChoices: datoTecnicoChoices,
        datoTecnico: false,
        instalations: {},
        editedInstalations: {},
        visibleIds: []
      }, () => {
        this.fetchResults()
      })
    } else if (name === "empresa") {
      this.setState({
        empresa: value,
        totalResults: 0,
        instalations: {},
        editedInstalations: {},
        visibleIds: []
      }, () => {
        if (!!this.state.tipoInstalacion) { this.fetchResults() }
      })
    } else if (name === "datoTecnico") {
      this.setState({ datoTecnico: value })
    }
  }

  handleSearchChange = () => (event, value, old_value, name) => {
    this.debouncedThing(value)
  }

  doTheThing(value) {
    this.setState({
      search: value,
      totalResults: 0,
      instalations: {},
      editedInstalations: {},
      visibleIds: []
    }, () => this.fetchResults())
  }

  handleFilterSubmit(values) {
    this.setState({
      empresa: values.empresa || false,
      tipoInstalacion: values.tipoInstalacion || false,
      datoTecnico: values.datoTecnico || false,
    })
    this.fetchResults()
  }

  handleSelect = (id) => (event) => {
    const selectedIds = new Set(this.state.selectedIds)
    if (selectedIds.has(id)){
      selectedIds.delete(id)
    } else {
      selectedIds.add(id)
    }
    this.setState({ selectedIds: selectedIds })
  }

  handleStatusChange = () => (event) => {
    const instalationId = event.target.name.split(".")[0]
    const fieldName = event.target.name.split(".")[3]
    const instalation = this.state.editedInstalations[Number(instalationId)]
    instalation.datasheet["ESTADO_CERTIFICACION"][fieldName] = event.target.value
    this.setState({
      editedInstalations: {
        ...this.state.editedInstalations,
        [Number(instalationId)]: instalation,
      }
    })
  }

  handleChangeSelectedStatus(newState) {
    const {
      editedInstalations,
      selectedIds,
      tipoInstalacion,
      tiposInstalaciones
    } = this.state

    const schema = tiposInstalaciones[tipoInstalacion].datasheet

    const validatedInstalations = _.cloneDeep(editedInstalations)
    for (let id of selectedIds){
      const [instalationId, datoTecnico] = id.split(".")
      for (let property in schema.properties) {
        if (property === "ESTADO_CERTIFICACION") continue;
        if (property === datoTecnico) {
          validatedInstalations[instalationId].datasheet["ESTADO_CERTIFICACION"][property] = newState
        }
      }
    }

    this.setState({ editedInstalations: { ...validatedInstalations } })
  }

  handleChangeAllStatus(newState) {
    const {
      editedInstalations,
      datoTecnico,
      tipoInstalacion,
      tiposInstalaciones,
      visibleIds
    } = this.state

    const schema = tiposInstalaciones[tipoInstalacion].datasheet

    const validatedInstalations = {}
    for (let id of visibleIds){
      validatedInstalations[`${id}`] = _.cloneDeep(editedInstalations[`${id}`])
      for (let property in schema.properties){
        if (property === "ESTADO_CERTIFICACION") continue;
        if (!datoTecnico || (!!datoTecnico && property === datoTecnico)) {
          validatedInstalations[`${id}`].datasheet["ESTADO_CERTIFICACION"][property] = newState
        }
      }
    }

    this.setState({
      editedInstalations: {
        ...this.state.editedInstalations,
        ...validatedInstalations
      }
    })
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage }, () => this.fetchResults())
  }

  handlePerPageChange(newPerPage) {
    this.setState({
      currentPage: 1,
      perPage: newPerPage,
      visibleIds: []
    }, () => this.fetchResults())
  }

  handleSnackbarClose(event, reason) {
    this.setState({ snackbarOpen: false })
  }

  fetchResults() {
    const {
      empresa,
      search,
      tipoInstalacion,
      tiposInstalaciones,
    } = this.state
    if (!tipoInstalacion) return;

    const filter = {};
    if (!!empresa) { filter["propietario_id"] = empresa }
    if (!!search) { filter["search"] = search }
    const params = {
      pagination: {
        page: this.state.currentPage,
        perPage: this.state.perPage,
      },
      sort: {
        field: this.state.sortColumn,
        order: this.state.sortDirection
      },
      filter
    }
    const resource = tiposInstalaciones[tipoInstalacion].slug

    this.setState({ loading: true })
    dataProvider(GET_LIST, resource, params)
      .then(response => {
        const newInstalations = _.keyBy(response.data, 'id')
        this.setState({
          loading: false,
          instalations: {
            ..._.cloneDeep(newInstalations),
            ...this.state.instalations,
          },
          editedInstalations: {
            ..._.cloneDeep(newInstalations),
            ...this.state.editedInstalations
          },
          totalResults: response.total,
          visibleIds: _.map(response.data, r => Number(r.id))
        })
      })
      .catch(error => {
        console.log(error)
      })
  }

  handleClear() {
    this.setState({ editedInstalations: _.cloneDeep(this.state.instalations) })
  }

  handleSave() {
    const {
      instalations,
      editedInstalations,
      tipoInstalacion,
      tiposInstalaciones
    } = this.state

    if (!!!tipoInstalacion) return;

    const resource = tiposInstalaciones[tipoInstalacion].slug
    this.setState({ saving: true })
    return Promise.all(_.map(_.values(editedInstalations), instalation => {
      const params = {
        id: instalation.id,
        data: editedInstalations[instalation.id],
        previousData: instalations[instalation.id]
      }
      return dataProvider(UPDATE, resource, params)
        .then(response => {
          this.setState({
            instalations: {
              ...this.state.instalations,
              [Number(instalation.id)]: _.cloneDeep(editedInstalations[instalation.id])
            }
          })
        })
    })).then(() => {
      this.setState({ saving: false, snackbarOpen: true, snackbarError: false })
    }).catch(error => {
      this.setState({ saving: false, snackbarOpen: true, snackbarError: true })
    })
  }

  componentDidMount() {
    const params = {
      pagination: {
        page: 1,
        perPage: 1000,
      },
      sort: { field: 'id', order: 'ASC' },
      filter: {
        active: true,
        id__not_in: "1,2"
      }
    }

    dataProvider(GET_LIST, "tipos-instalaciones", params)
      .then(response => {
        this.setState({
          tiposInstalaciones: _.keyBy(response.data, 'slug'),
          tipoInstalacionChoices: _.map(response.data, tipo => {
            return { value: tipo.slug, text: tipo.name }
          }).sort((a, b) => {
            if (a.text < b.text) return -1
            if (a.text === b.text) return 0
            return 1
          })
        })
      })
      .catch(error => {
        console.log(error)
      })
  }

  render() {
    const { tipoInstalacion, tiposInstalaciones } = this.state
    const { classes } = this.props

    const schema = _.get(tiposInstalaciones, `${tipoInstalacion}.datasheet`, {})

    return (
      <Authenticated
        authParams={{ required: true, roles: ["admin", "coordinador", "externo"] }}
        location={this.props.location}
      >
        <Card className={classes.root}>
          <CardContent>
            <Typography className={classes.title}>
              <CertificationIcon /> Certificar Datos Técnicos
            </Typography>
            <Grid container spacing={16}>
              <Grid item xs={12}>
                <CertificationFilters
                  tipoInstalacionChoices={this.state.tipoInstalacionChoices}
                  datoTecnicoChoices={this.state.datoTecnicoChoices}
                  onChange={this.handleFilterChange}
                  onSearchChange={this.handleSearchChange}
                  onSubmit={this.handleFilterSubmit}
                />
              </Grid>
              <Grid item xs={12}>
                {!tipoInstalacion && <p>Escoja un tipo de Instalación</p>}
                {tipoInstalacion && (
                  <CertificationTable
                    instalations={this.state.editedInstalations}
                    ids={this.state.visibleIds}
                    selectedIds={this.state.selectedIds}
                    total={this.state.totalResults}
                    resource={tiposInstalaciones[tipoInstalacion].slug}
                    schema={schema}
                    datoTecnico={this.state.datoTecnico}
                    page={this.state.currentPage}
                    perPage={this.state.perPage}
                    isLoading={this.state.loading}
                    onSelect={this.handleSelect}
                    onStatusChange={this.handleStatusChange}
                    changeSelectedStatus={this.handleChangeSelectedStatus}
                    changeAllStatus={this.handleChangeAllStatus}
                    onClear={this.handleClear}
                    onSave={this.handleSave}
                    onPageChange={this.handlePageChange}
                    onPerPageChange={this.handlePerPageChange}
                  />
                )}
              </Grid>
            </Grid>
          </CardContent>
          <Snackbar
            open={this.state.snackbarOpen}
            onClose={this.handleSnackbarClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={6000}
            message={this.state.snackbarError
              ? <span id="message-id">Error al guardar los cambios</span>
              : <span id="message-id">Registros actualizados correctamente</span>
            }
            ContentProps={{
              className: this.state.snackbarError ? classes.snackbarWarning : ""
            }}
          />
        </Card>
      </Authenticated>
    )
  }
}

export default withRouter(withStyles(styles)(Certification))
